(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            //  if(config.url && config.url.startsWith('api/'))
            //  config.url="http://reserweb.ir/admin/"+config.url;
            /*jshint camelcase: false */
            //
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token && (!(config.url && config.url.startsWith("api/authenticate")))) {
                if(config.url != "https://panel2.plnstage.ir/urls.json"){
                    config.headers.Authorization = 'Bearer ' + token;
                }
            }

            return config;
        }
    }
})();
